import {connect} from 'react-redux';
import {nsLoginSelect} from '../../redux/selector/nsLoginSelector'
import {startNSLogin} from '../../redux/slice/nsLoginSlice'
import {
    Header, 
    Paragraph, 
    LoginButton
} from '../../components/RegularComponents'
import { 
    APPLICATION_MODE_RENEW, 
    APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE, 
    APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE, 
    ROUTE_PATH, 
    SEGUE_NAME 
} from '../../app/constants';
import Navigation from '../Navigation';
import { 
    saveSegueDetails 
} from '../../redux/slice/primaryAgencyApplicationSlice';
import { isMaintenanceModeOn } from '../../app/SystemMaintenanceModeUtils';
import { SystemMaintenanceMessage } from '../../components/SystemMaintenanceMessage';

function NsLogin (props) { 
    const {dispatch} = props
    let {nsLogin} = props
    const {loginStatus} = nsLogin
    const{applicationType, applicationMode} = props.match.params

    if(nsLogin[applicationType]) { 
        nsLogin = nsLogin[applicationType]
    }

    const onLoginClick = () => {
        let appType = applicationType

        if(ROUTE_PATH.PB_APP.search(applicationType) !== -1) {
            appType = APPLICATION_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_LICENCE
        } else if (ROUTE_PATH.CO_APP.search(applicationType) !== -1) { 
            appType = APPLICATION_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_LICENCE
        }

        dispatch(saveSegueDetails({
            name : SEGUE_NAME.LOGIN,
            applicationType : appType,
            applicationMode
        }))

        dispatch(startNSLogin())
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="nslogin-header-id"
                        header={(applicationMode === APPLICATION_MODE_RENEW) ? 
                                nsLogin.headerRenewal : nsLogin.header}/>
                    <Paragraph 
                        id="nslogin-text-id"
                        text={(applicationMode === APPLICATION_MODE_RENEW) ? 
                                nsLogin.textRenewal : nsLogin.text} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <LoginButton 
                        disabled={isMaintenanceModeOn()}
                        style={{marginTop: "20px"}}
                        onClick={onLoginClick}
                        header={"Login / Create Account"}
                        subHeader={"A secure way to access Government of Nova Scotia online services"}
                    />

                    {loginStatus === "in-progress" ? 
                        <div className="fa-2x">
                            <i className="fa fa-spinner fa-spin" style={{padding: "10px"} }>
                            </i>
                        </div> : null}
                </div>
            </div>
            <SystemMaintenanceMessage />
        </div>
        </>
    )
}

export default connect(nsLoginSelect)(NsLogin)